import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environments/environment';

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { isEmptyString } from '@app/submodules/shared/utils';

enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

if(environment.production) {
  if (environment.hotjarId > 0) {
    setupHotjar();
  }

  if(!isEmptyString(environment.googleAnalyticsId)) {
    setupGoogleAnalytics();
  }
}

function setupHotjar() {
  let hotjarId = environment.hotjarId;
  let hotjarScript = document.createElement('script');
  hotjarScript.type = 'text/javascript';
  hotjarScript.async = true;
  hotjarScript.innerHTML = `
      (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:${hotjarId},hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
  document.head.appendChild(hotjarScript);
}

function setupGoogleAnalytics() {
  let googleAnalyticsId = environment.googleAnalyticsId;
  let googleAnalyticsScript = document.createElement('script');
  googleAnalyticsScript.type = 'text/javascript';
  googleAnalyticsScript.async = true;
  googleAnalyticsScript.innerHTML = `<!-- Google Tag Manager -->
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${googleAnalyticsId}');
  <!-- End Google Tag Manager -->`;

  document.head.appendChild(googleAnalyticsScript);

  let googleNoScript = document.createElement('noscript');
  googleNoScript.innerHTML = `<!-- Google Tag Manager (noscript) -->
  <iframe src="https://www.googletagmanager.com/ns.html?id=${googleAnalyticsId}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>
  <!-- End Google Tag Manager (noscript) -->`;
  document.body.appendChild(googleNoScript);
}